import { render, staticRenderFns } from "./update-tenant.vue?vue&type=template&id=726a195a"
import script from "./update-tenant.vue?vue&type=script&lang=ts"
export * from "./update-tenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports